import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import Swal from 'sweetalert2';
import { TokenUtils } from '@/utils/TokenUtils';
import UserService from '@/services/UserService';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
  {
    path: '/pos',
    name: 'pos',
    component: () => import(/* webpackChunkName: "about" */ '../views/POS.vue'),
  },
  {
    path: '/deliveries',
    name: 'deliveries',
    component: () => import(/* webpackChunkName: "deliveries" */ '../views/DeliveriesView.vue'),
    meta: { requiresAuth: true, attribute: 'VIEW_CLIENT_DELIVERIES' },
  },
  {
    path: '/deliveries/dispatch/:folio',
    name: 'order-dispatch', // Es estándar usar kebab-case para nombres de rutas
    component: () => import(/* webpackChunkName: "order-dispatch" */ '@/components/Deliveries/OrderDispatch.vue'),
    meta: { requiresAuth: true, attribute: 'VIEW_CLIENT_DELIVERIES' },
  },
  {
    path: '/deliveries/history/:folio',
    name: 'delivery-history-detail',
    component: () => import(/* webpackChunkName: "delivery-history-detail" */ '@/components/Deliveries/DeliveryHistoryDetail.vue'),
    meta: { requiresAuth: true, attribute: 'VIEW_CLIENT_DELIVERIES' },
  },
  {
    path: '/deliveries/deferred-preview/:folio',
    name: 'deferred-delivery-preview',
    component: () => import(/* webpackChunkName: "deferred-delivery-preview" */ '../components/Deliveries/DeferredDeliveryPreview.vue'),
  },
  {
    path: '/vale/resguardo/:folio/:mode?',
    name: 'resguardo-vale-ticket',
    component: () => import(/* webpackChunkName: "resguardo-vale" */ '../views/ValeResguardo.vue'),
  },
  {
    path: '/configuration',
    name: 'configuration',
    component: () => import('../views/Configuration.vue'),
  },
  {
    path: '/cash-closing',
    name: 'cash-closing',
    component: () => import('../views/CashClosing.vue'),
  },
  {
    path: '/cash-start',
    name: 'cash-start',
    component: () => import('../views/CashStart.vue'),
  },
  {
    path: '/valeresguardo',
    name: 'ValeResguardo',
    component: () => import('../views/ValeResguardo.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiredAttribute = to.meta.attribute;

  if (requiresAuth) {
    const token = localStorage.getItem('token') || localStorage.getItem('ticket');
    if (!token) {
      return next('/login');
    }

    if (requiredAttribute) {
      try {
        const jwtData = TokenUtils.getJwtData();

        if (jwtData && jwtData.identity) {
          // 1. Vamos al backend a traer los atributos reales guardados en la BD justo ahora
          const currentAttributes = await UserService.getUserAttributes(jwtData.identity);

          // 2. Actualizamos el almacén de Vuex en caliente
          await store.dispatch('setAttributes', currentAttributes);
        }
      } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error('Error de red al validar atributos en tiempo real:', error);
        // Si la API de permisos falla (caída de internet, etc.), por seguridad
        // dejamos que evalúe con lo que tiene en memoria o puedes mandarlo a /pos
      }

      // 3. Evaluamos la condición con los datos recién bajados del servidor
      const userAttributes = store.getters.attributes || [];

      if (!userAttributes.includes(requiredAttribute)) {
        const permisosMensajes = {
          VIEW_CLIENT_DELIVERIES: 'gestionar las entregas de mercancía.',
        };

        const mensajeEspecifico = permisosMensajes[requiredAttribute] || 'acceder a este módulo protegido.';

        Swal.fire({
          icon: 'error',
          title: 'Acceso Denegado',
          text: `Tu usuario no cuenta con los permisos necesarios para ${mensajeEspecifico}`,
          confirmButtonColor: '#1976D2',
          confirmButtonText: 'Entendido',
        });

        return next('/pos');
      }
    }
  }

  return next();
});

export default router;
